import { render, staticRenderFns } from "./ScrapeProduct.vue?vue&type=template&id=2dbe6614&scoped=true&"
import script from "./ScrapeProduct.vue?vue&type=script&lang=js&"
export * from "./ScrapeProduct.vue?vue&type=script&lang=js&"
import style0 from "./ScrapeProduct.vue?vue&type=style&index=0&id=2dbe6614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe6614",
  null
  
)

export default component.exports